import React, { useState } from "react";
import { masterApis } from "stores/master/masterApis";
import { jarvisRMSOnboardingApis } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingApis";
import { dateTimeHelper } from "helper/dateTime";
import CKYCauto from "components/Onboarding/CKYCauto";
import Stack from "components/common/Stack";
import Image from "components/common/Image";
import AppBar from "components/common/AppBar";
import { useMediaQuery, useTheme } from "@mui/material";
import { useHistory } from "react-router-dom";
import { customerActions } from "stores/customer/customerActions";
import { useDispatch } from "react-redux";

const ReKyc = ({ getRMSOnboardingDataAction }) => {
  const [formData, setFormData] = useState({
    panNumber: "",
    aadharNumber: "",
    dateOfBirth: "",
    inputIdType: "C",
    otp: "",
  });

  const [manageForm, setManageForm] = useState({
    docType: "",
    docVerify: false,
  });

  const [formError, setFormError] = useState({
    aadharNumber: "",
    panNumber: "",
    dateOfBirth: "",
    panCard: "",
    aadharCardFront: "",
    aadharCardBack: "",
    otp: "",
  });

  const [imagesUploadingLoader, setImagesUploadingLoader] = useState({
    panCard: false,
    aadharCardFront: false,
    aadharCardBack: false,
  });

  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [enableManually, setEnableManually] = useState(false);
  const [hasFirstAttempError, setHasFirstAttempError] = useState(false);
  const [reKycButton, setReKycButton] = useState(false);
  const dispatch = useDispatch()

  const theme = useTheme();
  const history = useHistory();

  const handleChange = ({ name, value }) => {
    if (name === "docType") {
      setManageForm((prevManageForm) => ({ ...prevManageForm, [name]: value }));
    } else {
      setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    }
  };

  const handleValidation = () => {};

  const handleVerification = async () => {
    setIsLoading(true);
    setHasFirstAttempError(false);
    setReKycButton(true);

    try {
      const res = await masterApis.verfyAutoKYC({
        dateOfBirth: dateTimeHelper.dateOfBirth(formData.dateOfBirth),
        pan: formData.panNumber,
      });

      if (res.code == "KYC009") {
        setIsVerified(true);
        setIsLoading(false);
        // getRMSOnboardingDataAction();
        await masterApis.submitKYCApi({productCode:"ISRENEWAL"});
        dispatch(customerActions.getProfile());
        history.goBack();
        dispatch(customerActions.getProfile());
        // console.log("res", res);
      } else {
        setHasFirstAttempError(true);
      }
    } catch (e) {
      setHasFirstAttempError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleKYCtype = (val) => {
    setEnableManually(val);
  };
  return (
    <>
      <AppBar color="inherit" sx={{}}>
        <Stack
          sx={{ paddingLeft: 10, paddingTop: "20px", paddingBottom: "20px" }}
        >
          <Image src="/jarvis-logo.svg" width={100} height={"auto"} />
        </Stack>
      </AppBar>
      <Stack padding={10} sx={{ mt: 10, padding: { xs: "20px", md: 10 } }}>
        <CKYCauto
          formData={formData}
          formError={formError}
          isVerified={isVerified}
          isLoading={isLoading}
          hasFirstAttempError={hasFirstAttempError}
          handleChange={handleChange}
          handleVerification={handleVerification}
          toggleKYCtype={toggleKYCtype}
          isReKyc={true}
          reKycButton={reKycButton}
        />
      </Stack>
    </>
  );
};

export default ReKyc;
